import { Button, Card, Col, Form, Row, Select, Table } from "antd";
import { GetInputOutputHistory } from "../../RestAPI/dbo/InOutapi";
import { useEffect, useState } from "react";
import { DownloadOutlined } from "@ant-design/icons";


const { Option } = Select;
function InOut() {

    const columns = [
        {
            title: ' تاریخ',
            dataIndex: 'Date',
            key: 'Date',
        },
        {
            title: 'روز',
            dataIndex: 'NameDay',
            key: 'NameDay',
        },
        {
            title: 'ساعت ورود',
            dataIndex: 'ITime',
            key: 'ITime',
        },
        {
            title: 'ساعت خروج',
            dataIndex: 'OTime',
            key: 'OTime',
        },
        {
            title: 'وضعیت ورود',
            dataIndex: 'TypeIN',
            key: 'TypeIN',
        },
        {
            title: 'وضعیت خروج',
            dataIndex: 'TypeOut',
            key: 'TypeOut',
        },
    ];

    const [list, setList] = useState<Array<{}>>([]);

    async function fetchData(values: any) {
        const res = await GetInputOutputHistory(values.year, values.month);
        setList(res)
    }


    const currentYear = new Date().getFullYear();
    const persianYear = currentYear - 621;
    const years = Array.from({ length: persianYear - 1402 + 1 }, (_, i) => 1402 + i);
    const months = [
        { value: 1, label: "فروردین" },
        { value: 2, label: "اردیبهشت" },
        { value: 3, label: "خرداد" },
        { value: 4, label: "تیر" },
        { value: 5, label: "مرداد" },
        { value: 6, label: "شهریور" },
        { value: 7, label: "مهر" },
        { value: 8, label: "آبان" },
        { value: 9, label: "آذر" },
        { value: 10, label: "دی" },
        { value: 11, label: "بهمن" },
        { value: 12, label: "اسفند" },
    ];
    return (<>

        <Card style={{ margin: 10, direction: "rtl" }}>
            <Form
                layout="vertical"
                style={{ maxWidth: "600px", margin: "auto" }}
                onFinish={fetchData}
            >
                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12}>
                        <Form.Item
                            name="year"
                            label="سال"
                            rules={[{ required: true, message: "لطفاً یک سال انتخاب کنید!" }]}
                        >
                            <Select placeholder="انتخاب سال">
                                {years.map((year) => (
                                    <Option key={year} value={year}>
                                        {year}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                        <Form.Item
                            name="month"
                            label="ماه"
                            rules={[{ required: true, message: "لطفاً یک ماه انتخاب کنید!" }]}
                        >
                            <Select placeholder="انتخاب ماه">
                                {months.map((month) => (
                                    <Option key={month.value} value={month.value}>
                                        {month.label}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24}>
                        <Form.Item>
                            <Button type="primary" htmlType="submit" block icon={<DownloadOutlined />} >
                                دریافت اطلاعات
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Card>


        <Card
            title="سوابق حضور"
            style={{ margin: 10 }}
        >
            <Table
                pagination={false}
                dataSource={list}
                columns={columns}
                scroll={{ x: 'max-content' }}
            />


        </Card>
    </>);
}

export default InOut;